import { render, staticRenderFns } from "./EmailSmsLogDetail.vue?vue&type=template&id=590ee1b4&scoped=true"
import script from "./EmailSmsLogDetail.vue?vue&type=script&lang=js"
export * from "./EmailSmsLogDetail.vue?vue&type=script&lang=js"
import style0 from "./EmailSmsLogDetail.vue?vue&type=style&index=0&id=590ee1b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ee1b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590ee1b4')) {
      api.createRecord('590ee1b4', component.options)
    } else {
      api.reload('590ee1b4', component.options)
    }
    module.hot.accept("./EmailSmsLogDetail.vue?vue&type=template&id=590ee1b4&scoped=true", function () {
      api.rerender('590ee1b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/emailsmslog/EmailSmsLogDetail.vue"
export default component.exports